<div>
  <ion-select
    [label]="'month.month' | translate"
    mode="md"
    label-placement="floating"
    fill="outline"
    (ionChange)="selectedValueChanged.emit($event.detail.value)"
    [multiple]="multiple"
    [value]="preselectedMonth"
    interface="popover"
  >
    @if (showAllEntry) {
    <ion-select-option [value]="null">{{
      "month.all" | translate
    }}</ion-select-option>
    } @for (value of this.values; track value) {
    <ion-select-option [value]="this.values.indexOf(value)">{{
      value | translate
    }}</ion-select-option>
    }
  </ion-select>
  <ion-select
    style="width: 125px; margin-left: 5px"
    [label]="'month.year' | translate"
    mode="md"
    label-placement="floating"
    fill="outline"
    (ionChange)="selectedYearChanged.emit($event.detail.value)"
    [value]="preselectedYear"
    interface="popover"
  >
    @for (value of this.years; track value) {
    <ion-select-option [value]="value">{{ value }}</ion-select-option>
    }
  </ion-select>
</div>
